import React from 'react';
import { Popover, OverlayTrigger } from 'react-bootstrap';
import Icon from 'modules/react/components/stateless/Icon';
import PropTypes from 'prop-types';
import style from './PageListActions.scss';

const propTypes = {
  authorized: PropTypes.bool.isRequired,
  action: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
  option: PropTypes.element.isRequired,
  showLock: PropTypes.bool,
};

const defaultProps = {
  showLock: true,
};

const renderPopover = (action, showLock) => (
  <Popover id="disabled-action" className="pageActionTooltip">
    {showLock && <Icon id="circle-lock" label="disabled action" />}
    <span className={style.tooltipMsg}>
      {typeof action === 'string' ? `You don't have permission to ${action} this page.` : action.message}
    </span>
  </Popover>
);

const renderOverlay = ({
  authorized, action, showLock, option,
}) => (
  <OverlayTrigger
    overlay={renderPopover(action, showLock)}
    placement="left"
    trigger={authorized ? null : ['hover', 'focus']}
  >
    {option}
  </OverlayTrigger>
);

renderOverlay.propTypes = propTypes;
renderOverlay.defaultProps = defaultProps;

export default renderOverlay;
